<template>
  <header id="header" :class="{'scrolled': scrolled, 'navOpen': nav}">
    <div id="header_left">
      <router-link to="/"><AppLogo /></router-link>
    </div>

    
    <div v-if="false" id="header_right" class="no-print">
      <AppLoader v-if="authLoading" size="small" style="margin-right: .75rem;" />
      <div id="header_user" v-if="user" @click="nav = !nav">
        <div id="user_name">{{ user.displayName.split(' ')[0] }}</div>
        <div id="avatar">
            <span>{{ user.displayName[0] }}</span>
            <img v-if="false" :src="'https://www.bitgab.com/uploads/profile/files/default.png' || photoURL" />
        </div>
        <div class="plan-tag" v-if="subscription?.plan.tag">{{ subscription.plan.tag }}</div>
      </div>
      <div v-else class="buttons">
        <AppButton @click="signIn" color="primary">{{ $t('auth.signin') }}</AppButton>
        <AppButton @click="signUp" color="primary" class="no-mobile">{{ $t('auth.signup') }}</AppButton>
      </div>
      <div id="nav_trigger"><AppButton @click="nav = !nav" :icon="nav ? 'close' : 'menu'" /></div>
    </div>

    <div id="nav">
      
      <div id="nav_top" v-scrollable>
        
        <div class="divider"></div>
        <template v-if="user && !authLoading">
          <AppButton @click="closeNav" :to="'/routes'" :icon="'directions'" fill>{{ $t('nav.routes') }}</AppButton>
          <AppButton @click="closeNav" :to="'/account'" :icon="'payment'" fill :class="subscription?.plan.id">{{ $t('nav.subscription') }}</AppButton>
          <AppButton v-if="false" @click="closeNav" :to="'/settings'" :icon="'settings'" fill>{{ $t('nav.settings') }}</AppButton>
          <AppButton v-if="false" @click="closeNav" :to="'/contacts'" :icon="'contacts'" fill>{{ $t('nav.contacts') }}</AppButton>
          <AppButton @click="changeTheme" :icon="theme == 'dark' ? 'wb_sunny' : 'brightness_2'" fill>{{ theme == 'dark' ? $t('nav.light_mode') : $t('nav.dark_mode') }}</AppButton>
          <AppButton @click="signOut" :icon="'exit_to_app'" class="color-error" fill>{{ $t('auth.signout') }}</AppButton>
        </template>
        <template v-else>
          <AppButton @click="signIn" icon="lock" fill>{{ $t('auth.signin') }}</AppButton>
          <AppButton @click="signUp" icon="person_add" fill>{{ $t('auth.signup') }}</AppButton>
        </template>
        <div class="divider"></div>
        <AppButton @click="closeNav" :to="'/about'" :icon="'emoji_objects'" fill>{{ $t('nav.about') }}</AppButton>
        <AppButton @click="closeNav" :to="'/faq'" :icon="'contact_support'" fill>{{ $t('nav.faq') }}</AppButton>

        <div class="divider"></div>
        <AppButton @click="closeNav" :to="'/privacy'" :icon="'security'" fill>{{ $t('nav.privacy') }}</AppButton>
        <AppButton @click="closeNav" :to="'/tos'" :icon="'gavel'" fill>{{ $t('nav.tos') }}</AppButton>
      </div>

      <div id="nav_bottom">
        <span>Made with <i class="material-icons color-error share-love" @click="shareLove">favorite</i> in Kgs. Lyngby</span>
      </div>
    </div>

    <div class="mask" :class="{'navOpen': nav}" @click="nav = false"></div>
  </header>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue'
import { store } from '@/store'
import AppLogo from '@/components/atoms/AppLogo.vue'
import router from '@/router'
import { toast } from '@/api/tools'

export default defineComponent({
  name: 'TripplyHeader',
  components: { AppLogo },
  setup() {

    const scrolled = ref(false)

    window.document.body.onscroll = () => {
      scrolled.value = window.pageYOffset > 0
    }

    const nav = ref(false)

    function signIn() {
      store.modal.showModal('SignIn')
    }
    function signUp() {
      store.modal.showModal('SignIn', { signUp: true })
    }
    function closeNav() {      
      nav.value = false
    }
    function signOut() {
      store.auth.signOut()
      closeNav()
    }
    function changeTheme() {
      store.global.changeTheme()
    }

    function shareLove() {
      toast({title: 'Tak fordi du deler kærligheden!', type: 'love'})
    }

    const user = store.auth.get(state => state.user)
    const subscription = computed(() => store.user.state.subscription)    
    const photoURL = user.value ? user.value.photoURL : null
    const firstName = store.user.firstName
    const theme = store.global.get(state => state.theme)
    const authLoading = store.auth.get(state => state.loading)

    return { user, closeNav, photoURL, firstName, signIn, signUp, signOut, subscription, nav, changeTheme, theme, authLoading, scrolled, shareLove }
  }
})
</script>

<style lang="scss">
#header {
  z-index: 1000000;
  padding: 0 var(--side-padding);
  height: var(--height-header);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  pointer-events: none;
  transition: box-shadow .2s;

  &.scrolled {
    box-shadow: 0 2px 16px rgba(0,0,0,0.04);
    background: var(--color-card);
    //border-bottom: 1px solid #eee;
  }
  &.scrolled, &.navOpen {
    color: var(--text-color-primary) !important;
  }
  &.navOpen {
    .mask {
      opacity: 1;
      pointer-events: all;
    }
    #nav {
      transform: translateX(0);
    }
  }

  .mask {
    z-index: 100000;
    opacity: 0;
  }

  .plan-tag {
    position: absolute;
    right: -1.25rem;
    top: -0.25rem;
    z-index: 100;
  }

  &_right, &_left, #nav {
    pointer-events: all;
  }

  &_right {
    z-index: 10000000;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &_user {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-radius: 1rem;
    font-weight: 500;
    position: relative;
    #user_name {
      white-space: nowrap;
    }
  }
}

#nav {
  color: var(--text-color-primary);
  padding: 3rem 0 2rem 0;
  position: fixed;
  z-index: 1000000;
  right: 0;
  top: 0;
  bottom: 0;
  background: var(--color-card);
  width: 20rem;
  box-shadow: var(--modal-shadow);
  transition: transform .3s;
  transform: translateX(22rem);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;

  &_trigger {
    margin-left: 1rem;
  }
  &_top {
    overflow-y: auto;
    padding: 0 .5rem 1rem;
  }

  &_bottom {
    span {
      display: flex;
      line-height: 1rem;
      font-size: .75rem;
      justify-content: center;
      align-items: center;
      i {
        font-size: 1rem;
        margin: 0 .25rem;
      }
    }
  }

  button {
    border-radius: 0;
  }
}

#avatar {
  margin-left: .75rem;
  flex: 0 0 2.5rem;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 1rem;
  background: linear-gradient(36deg, rgba(118,9,121,1) 0%, rgba(0,212,255,1) 100%);
  color: white;
  font-weight: 600;
  font-size: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  border: 3px solid white;

  .pro {
    position: fixed;
    background: var(--color-primary);
    font-size: .75rem;
    padding: 0 .25rem;
    border-radius: 1rem;
    margin: -2.5rem -2rem 0 0;
  }

  img {
    width: 100%;
  }
}

.share-love:hover {
  cursor: pointer;
}

#language-change {
  position: absolute;
  top: 0;
  left: 1rem;
}

@media only print {
  #header {
    position: absolute;
  }
}

@media only screen and (max-width: 480px) {
  #header {
    padding-right: .5rem;
  }
}
</style>